module.exports = __webpack_public_path__ + "static/img/020_3.5f6c287.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/020_3.jpg
// module id = Puq1
// module chunks = 1